import React from 'react';
import classnames from 'classnames';
import { HEATMAP_DIAG_RASTER_SCREEN_INDEXES } from '../utils/constants';
import './HeatmapDiagRasterWarningScreen.css';

const HeatmapDiagRasterWarningScreen = (props) => {
  return (
    <div id="HeatmapDiagRasterWarningScreen_Container" className="HeatmapDiagRasterWarningScreen_Container">
      <div id="HeatmapDiagRasterWarningScreen_TopContainer" className="HeatmapDiagRasterWarningScreen_TopContainer">
        <div id="HeatmapDiagRasterWarningScreen_HeaderText" className={'HeatmapDiagRasterWarningScreen_HeaderText'}>
          Diagnostic Raster Warning
        </div>
        <div id="HeatmapDiagRasterWarningScreen_MessageText" className="HeatmapDiagRasterWarningScreen_MessageText">
          Performing the Diagnostic Raster will take this device OUT OF SERVICE. Please confirm that taking this device
          OUT OF SERVICE is desired. Select “Proceed with Diagnostic Raster” below to continue or “Cancel” to exit.
        </div>
      </div>
      <div
        id="HeatmapDiagRasterWarningScreen_BottomContainer"
        className="HeatmapDiagRasterWarningScreen_BottomContainer"
      >
        <button
          id="HeatmapDiagRasterWarningScreen_Bottom_CancelButton"
          className={classnames({
            HeatmapDiagRasterWarningScreen_Bottom_CancelButton: true
          })}
          onClick={() => {
            props.onClose();
          }}
        >
          Cancel
        </button>
        <button
          type="submit"
          id="HeatmapDiagRasterWarningScreen_Bottom_ActionButton"
          className={classnames({
            HeatmapDiagRasterWarningScreen_Bottom_ActionButton: true
          })}
          onClick={() => {
            props.setScreenIndex(HEATMAP_DIAG_RASTER_SCREEN_INDEXES.CONFIG);
          }}
        >
          Proceed with Diagnostic Raster
        </button>
      </div>
    </div>
  );
};

export default React.memo(HeatmapDiagRasterWarningScreen);
